function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m19 20h-15c-1.11 0-2-0.9-2-2v-12c0-1.11 0.89-2 2-2h6l2 2h7c1.097 0 2 0.903 2 2h-17v10l2.14-8h17.07l-2.28 8.5c-0.23 0.87-1.01 1.5-1.93 1.5z",
  fill: "#4caf50"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipRule: "evenodd",
  fill: "#c8e6c9",
  fillRule: "evenodd",
  strokeLinejoin: "round",
  strokeMiterlimit: 1.4142
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.70678 0 0 .70678 2.0645 -.22446)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m19.146 30.989c-0.07 0-0.139-9e-3 -0.207-0.025-0.519-0.152-0.837-0.684-0.726-1.213l2.709-14.431c0.049-0.279 0.209-0.525 0.444-0.683 0.206-0.136 0.46-0.18 0.7-0.122 0.519 0.152 0.837 0.684 0.727 1.213l-2.716 14.432c-0.048 0.278-0.208 0.524-0.442 0.681-0.145 0.096-0.315 0.147-0.489 0.148z",
  fill: "#c8e6c9",
  fillRule: "nonzero"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.70678 0 0 .70678 2.0645 -.22446)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m24.578 28.944h-0.068c-0.266-0.024-0.51-0.161-0.668-0.377-0.317-0.432-0.274-1.036 0.1-1.419l4.658-4.553-4.638-4.239c-0.385-0.372-0.445-0.975-0.141-1.416 0.152-0.222 0.394-0.368 0.661-0.4 0.259-0.028 0.518 0.059 0.709 0.237l5.47 5c0.386 0.372 0.448 0.974 0.144 1.416-0.042 0.059-0.089 0.114-0.142 0.163l-5.447 5.324c-0.17 0.168-0.399 0.263-0.638 0.264z",
  fill: "#c8e6c9",
  fillRule: "nonzero"
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(.70678 0 0 .70678 2.0645 -.22446)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16.423 28.947c-0.24-2e-3 -0.469-0.098-0.639-0.267l-5.452-5.327c-0.05-0.046-0.094-0.097-0.132-0.153-0.306-0.44-0.246-1.043 0.141-1.414l5.471-5c0.187-0.178 0.443-0.265 0.7-0.238 0.269 0.031 0.511 0.177 0.665 0.4 0.305 0.441 0.246 1.044-0.14 1.417l-4.637 4.235 4.659 4.551c0.377 0.382 0.42 0.988 0.1 1.419-0.158 0.216-0.402 0.354-0.669 0.377z",
  fill: "#c8e6c9",
  fillRule: "nonzero"
})));

var SvgFolderSrcOpen = function SvgFolderSrcOpen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 1.4142,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFolderSrcOpen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/folder-src-open.c2ca6242.svg";
export { ForwardRef as ReactComponent };